import { usePageTracking } from "@/hooks/usePageTracking";

const PageTracker = () => {
  usePageTracking();
  return null;
};

export default PageTracker;
